import {
  DateInput,
  TabbedForm,
  required,
  useNotify,
  usePermissions,
  useRedirect,
  useRefresh,
} from "react-admin";
import {
  FormTab,
  Group,
  GroupItem,
  Toolbar,
  TransactionLogsField,
  TransactionNotesInput,
  TransactionNotesIsPrivateInput,
  useFieldLabel,
  useSaveMutation,
} from "ra-friendsofbabba";
import { MediaInput, UserInput } from "../component/input";

import DirtyAlert from "../component/alert/DirtyAlert";
import ExportButton from "./buttons/ExportButton";
import Input from "../component/input/Input";
import PrintAlert from "../component/alert/PrintAlert";
import { PrintButton } from "../component/button";
import React from "react";
import TechnicalReportsInput from "./inputs/TechnicalReportsInput";
import TroProfileInput from "./inputs/TroProfileInput";
import UserBreaksField from "./fields/UserBreaksField";
import UsersField from "./fields/UsersField";
import { get } from "lodash";

const isPrintDisabled = (props) =>
  props?.record?.status !== "completed" ||
  props?.record?.technical_reports?.length === 0;

const isPrintVisible = (props) =>
  props?.record?.transaction?.state === "confirmed" ||
  props?.record?.transaction?.state === "integrations_requested";

const Form = (props) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions(["admin"]);
  const fieldLabel = useFieldLabel({ ...props });
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      const prevState = get(values, "transaction.state");
      const nextState = get(response, "data.state");
      const isMoved = prevState !== nextState;
      notify(
        `resources.substitutive-declarations.messages.${values.state}_${
          isMoved ? "moved" : "loop"
        }.save_success`
      );
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });

  return (
    <TabbedForm
      {...props}
      initialValues={{ state: "draft" }}
      save={save}
      toolbar={
        <Toolbar useWorkflow maxButtonsToDisplay={1}>
          <ExportButton mode="form" isAdmin={isAdmin} />
        </Toolbar>
      }
    >
      <FormTab label="resources.substitutive-declarations.tabs.general">
        <PrintAlert visible={isPrintVisible} disabled={isPrintDisabled}>
          <PrintButton label="ra.action.generate_zip" action="export.zip" />
        </PrintAlert>
        <Group fullWidth>
          <GroupItem lg={8} md={10} sm={12}>
            <Input
              source="user_id"
              fullWidth
              filter={{ role: "tro" }}
              validate={required()}
              component={<UserInput />}
            />
          </GroupItem>
        </Group>
        <Group fullWidth>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <Input
              source="start"
              validate={required()}
              component={<DateInput />}
            />
          </GroupItem>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <Input
              source="end"
              validate={required()}
              component={<DateInput />}
            />
          </GroupItem>
        </Group>
        <Input
          fullWidth
          source="tro"
          label={fieldLabel("tro")}
          component={<TroProfileInput />}
        />
        <DirtyAlert
          message={"resources.substitutive-declarations.messages.dirty_alert"}
        />
        <Input source="researchers" component={<UsersField />} />
        <Input source="user_breaks" component={<UserBreaksField />} />
        <Input
          source="technical_reports"
          component={<TechnicalReportsInput />}
          fullWidth
        />
        <Input source="media" component={<MediaInput />} fullWidth />
        <TransactionLogsField source="logs" admin={isAdmin} fullWidth />

        <TransactionNotesInput source="notes" fullWidth />
        <TransactionNotesIsPrivateInput
          admin={isAdmin}
          source="is_private"
          fullWidth
        />
      </FormTab>
    </TabbedForm>
  );
};
export default Form;
